// can be replaced with URL.canParse() when it will be supported for all browsers

export const urlCanParse = url => {
  try {
    return Boolean(new URL(url));
  } catch (e) {
    return false;
  }
};
